import PropTypes from 'prop-types'
import { componentOrElement } from 'prop-types-extra'
import React from 'react'

import LazyComponent from '../lazy-component'
import { ErrorIcon, SuccessIcon, WarningIcon } from '../svg-icon'
import ToolbarOverlay from '../toolbar-overlay'
import style from './style.scss'

const DEFAULT_TIMEOUT = 5000

export const NOTIFICATION_TYPE = {
    danger: 'danger',
    info: 'info',
    success: 'success',
    warning: 'warning'
}

/**
 * Displays a page level notification
 * Can be dismissed via timeout and/or manually
 */
export default class NotificationControl extends LazyComponent {
    static propTypes = {
        bsStyle: PropTypes.oneOf(['danger', 'info', 'success', 'warning']).isRequired,
        children: PropTypes.node,
        container: PropTypes.oneOfType([componentOrElement, PropTypes.func]),
        dismissable: PropTypes.bool,
        onDismiss: PropTypes.func,
        show: PropTypes.bool,
        showFullText: PropTypes.bool,
        timeout: PropTypes.number
    }

    static defaultProps = {
        showFullText: false,
        timeout: DEFAULT_TIMEOUT
    }

    constructor(props, context) {
        super(props, context)

        this.hideNotificationTID = null

        this.loadModules([
            'classnames',
            'react-bootstrap'
        ])

        this.handleNotificationTimeout = this.handleNotificationTimeout.bind(this)
    }

    componentWillReceiveProps(newProps) {
        this.clearNotificationTimeout()

        if (newProps.show && newProps.timeout) {
            this.hideNotificationTID = setTimeout(this.handleNotificationTimeout, newProps.timeout)
        }
    }

    componentWillUnmount() {
        this.clearNotificationTimeout()
    }

    getIcon() {
        switch (this.props.bsStyle) {
            case NOTIFICATION_TYPE.danger:
                return <ErrorIcon />
            case NOTIFICATION_TYPE.success:
                return <SuccessIcon />
            case NOTIFICATION_TYPE.info:
            case NOTIFICATION_TYPE.warning:
                return <WarningIcon />
            default:
                return null
        }
    }

    clearNotificationTimeout() {
        if (this.hideNotificationTID) {
            clearTimeout(this.hideNotificationTID)
            this.hideNotificationTID = null
        }
    }

    handleNotificationTimeout() {
        this.clearNotificationTimeout()

        if (this.props.onDismiss) {
            this.props.onDismiss()
        }
    }

    lazyRender() {
        const { Alert, Overlay } = this.modules['react-bootstrap']
        const classNames = this.modules['classnames']
        const {
            bsStyle,
            children,
            container,
            dismissable,
            show,
            showFullText
        } = this.props

        return (
            <Overlay
                container={container}
                placement="top"
                show={show}
            >
                <ToolbarOverlay className={style.alertContainer}>
                    <Alert
                        bsStyle={bsStyle}
                        className={classNames(`${style.alert}`, `${showFullText ? style.showFullText : ''}`)}
                        onDismiss={dismissable ? this.handleNotificationTimeout : null}
                    >
                        {this.getIcon()}
                        {children}
                    </Alert>
                </ToolbarOverlay>
            </Overlay>
        )
    }
}



// WEBPACK FOOTER //
// src/components/notification/index.js